import {
    onNewFolderMenuClicked,
    onSearchTextChanged,
    onViewAllMenuClicked,
} from '../actions/internalActions';
import { getStore, initialStore } from '../store/store';
import { mutator } from 'satcheljs';

// reset text in search box
mutator(onNewFolderMenuClicked, () => {
    getStore().findText = initialStore.findText;
});

// set search box value in store by subscribing to onSearchTextChanged action
mutator(onSearchTextChanged, actionMessage => {
    getStore().findText = actionMessage.newSearchText;
});

// reset text in search box
mutator(onViewAllMenuClicked, () => {
    getStore().findText = initialStore.findText;
});
